import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import Icon from '../utils/Icon';
import Spinner from '../utils/Spinner';
import useHelpNoteTitle from '../utils/Translations/useHelpNoteTitle';
import styles from './IconButton.scss';
const IconButton = ({ title, tooltipTitle, iconName, className = '', iconClassName = '', isDisable = false, iconType = '', badge = '', isPageTitle = false, onClick, inline, hasBackground = true, isVisible = true, isSmall = false, isLarge = false, isLoading = false, hoverIconName, dataCy, ...props }) => {
    const resolvedTooltipTitle = useHelpNoteTitle(title, tooltipTitle);
    const handleClick = useCallback(e => !isDisable && onClick && onClick(e), [
        onClick,
        isDisable,
    ]);
    const _iconClassName = useMemo(() => classnames(iconClassName, {
        [styles.iconStyleWithBackground]: hasBackground,
        [styles.disabled]: isDisable,
        [styles.material_margin]: iconType === 'material',
        [styles.small]: isSmall,
        [styles.large]: isLarge,
        [styles.spinner]: isLoading,
    }), [
        isLoading,
        hasBackground,
        isDisable,
        iconClassName,
        iconType,
        isSmall,
        isLarge,
    ]);
    return (<a className={classnames(className, {
        [styles.buttonStyleWithBackground]: hasBackground,
        [styles['button-disabled']]: isDisable,
        [styles.pageTitle]: isPageTitle,
        [styles.inline]: !!inline,
        [styles['button-invisible']]: !isVisible,
    })} data-cy={dataCy} title={resolvedTooltipTitle || title} {...props} onClick={handleClick}>
      {isLoading ? (<Spinner className={_iconClassName} inline={inline}/>) : (<Icon badge={badge} className={_iconClassName} hoverName={hoverIconName} hoverTitle={resolvedTooltipTitle || title} name={iconName} type={iconType}/>)}
    </a>);
};
export default IconButton;
